import React, {
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import { EICSRadioData, RoutingProps } from './IntakeClientsInfo';
import { Box, Card, Grid, autocompleteClasses } from '@mui/material';
import KeyValueComponent from '../../components/forms/KeyValueComponent'; // DataJsonType,
import {
  IntakeFamilyHistoryInfoResponseType,
  getIntakeFamilyHistoryInfoDetails,
  putIntakeFamilyHistoryInfo,
} from '../../services/configApi/forms/Intake/IntakeServices';
import { Formik, FormikProps } from 'formik';
import * as yup from 'yup';
import DropdownComponent from '../../components/formlib/DropdownComponent';
import MediumTypography from '../../components/formlib/MediumTypography';
import {
  IntakeFamilyInfoEcoMapType,
  IntakeFamilyInfoEicsType,
  OptionType,
  ResponseType,
} from '../../utils/type';
import Textinput from '../../components/formlib/Textinput';
import QualificationJsonData from './IntakeJSON/FamilyHistory/Qualification.json';
import JobTypeJsonData from './IntakeJSON/FamilyHistory/JobType.json';
import CommentTextbox from '../../components/formlib/CommentTextbox';
import { formatPhoneNumber } from '../../utils/formValidationUtil';
import CustomRadioButton from '../../components/formlib/CustomRadioButton';
import { IntakeRadioData } from './IntakePregnancyInfo';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import ModalPopup from '../../components/formlib/ModalPopup';
import MultipleAutocompleteSearch from '../../components/formlib/MultipleAutocompleteSearch';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import { ApiError, isCustomError } from '../../services/ApiResponseHandler';
import { LookUpContext } from '../../context/LookUpContextProvider';
import { showCancelToaster } from './IntakeTabNavigationComponent';
import { UnSavedChangesContext } from '../../context/UnSavedChangesProvider';
import _, { debounce } from 'lodash';
import CheckBoxComponent from '../../components/formlib/CheckBoxComponent';
import { parentsMaritalStatus } from '../Dropdown';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import { useMultiplePermissions } from '../../hooks/usePermissions';
import { REFERRAL_STATUS_KEY } from '../../services/Constant';

export interface Data {
  name: string;
  dateOfBirth: string;
  school: string;
  grade: string;
  siblingType: string;
  actions: string;
}

export interface IntakeFamilyHistoryInfoType {
  eics: IntakeFamilyInfoEicsType;
  ecoMap: IntakeFamilyInfoEcoMapType;
  fatherRace: string;
  fatherEthnicity: string;
  motherRace: string;
  motherEthnicity: string;
  lastSchoolGradeDesc: string;
  education: string;
  occupation: string;
  employeedBy: string;
  employerAddress: string;
  workPhone: string;
  parentsMaritalStatus: string;
  kinshipCare: string;
  extendedFamilyDesc: string;
  involvedRegularlyInChild: string;
  weakenedImmuneSystem: string;
  weakenedImmuneSystemDesc: string;
  familyMedicalHistoryDesc: string;
  formHandleFlag: boolean;
  comment: string;
}

const IntakeFamilyHistoryInitialValues = {
  eics: {
    parent: {
      id: '',
      name: '',
      relationshipToClient: '',
      phoneNumber: '',
      address: '',
      email: '',
    },
    race: '',
    ethnicity: '',
    primarySpokenLanguage: '',
    primarySpokenLanguageOther: '',
    primaryWrittenLanguage: '',
    primaryWrittenLanguageOther: '',
    mothersEducationYear: '',
    lackingAdequate: '',
    homelessness: '',
    homelessnessInPast: '',
    protectiveServiceInvestigation: '',
    abuseAffectingChild: '',
    parentalChronicIllness: '',
    affectingChild: '',
    socialSupport: '',
    pets: '',
    smoking: '',
    unsecuredWeapons: '',
  },
  ecoMap: {
    whoWatchesChild: '',
    receivingFinancialSupport: '',
    receivingFinancialSupportDesc: '',
    additionalTherapies: '',
    additionalTherapiesDesc: '',
    livesInHomeDesc: '',
    familyTogetherDesc: '',
    spiritualGroups: '',
    spiritualGroupsDesc: '',
    importantPeopleDesc: '',
    emergencyCallDesc: '',
    anyoneImportantDesc: '',
    workType: '',
    workTypeDesc: '',
  },
  fatherRace: '',
  fatherEthnicity: '',
  motherRace: '',
  motherEthnicity: '',
  lastSchoolGradeDesc: '',
  education: '',
  occupation: '',
  employeedBy: '',
  employerAddress: '',
  workPhone: '',
  parentsMaritalStatus: '',
  kinshipCare: '',
  extendedFamilyDesc: '',
  involvedRegularlyInChild: '',
  weakenedImmuneSystem: '',
  weakenedImmuneSystemDesc: '',
  familyMedicalHistoryDesc: '',
  formHandleFlag: false,
  comment: '',
};

const validationSchema = yup.object().shape({
  formHandleFlag: yup.boolean(),
  race: yup.string().nullable(),
  ethnicity: yup.string().nullable(),
  motherRace: yup.string().nullable(),
  motherEthnicity: yup.string().nullable(),
  fatherRace: yup.string().nullable(),
  fatherEthnicity: yup.string().nullable(),
  education: yup.string().nullable(),
  educationYears: yup.string().nullable(),
  schoolCompleted: yup.string(),
  occupation: yup.string(),
  employeedBy: yup.string(),
  employerAddress: yup.string(),
  workPhone: yup.string(),
  jobType: yup.string(),
  jobTypeOther: yup.string(),
  primarySpokenLanguage: yup.string().nullable(),
  primarySpokenLanguageOther: yup.string().nullable(),
  primaryWrittenLanguage: yup.string().nullable(),
  primaryWrittenLanguageOther: yup.string().nullable(),
  parentsMaritalStatus: yup.string(),
  kinshipCare: yup.string(),
  withWhomChildLive: yup.string(),
  siblingNameId: yup.string().nullable(),
  school: yup.string(),
  grade: yup.string(),
  siblingType: yup.string().nullable(),
  pets: yup.string().nullable(),
  smoking: yup.string().nullable(),
  unsecuredWeapons: yup.string().nullable(),
  extendedFamily: yup.string(),
  compromisedImmuneSystem: yup.string(),
  familyMemberHistoryOther: yup.string(),
  parentalChronicIllness: yup.string().nullable(),
  affectingChild: yup.string().nullable(),
  siblingWithSEN: yup.string().nullable(),
  mothersEducationYear: yup.string().nullable(),
  mothersEducationYearCheck: yup.boolean().nullable(),
  povertyLevel: yup.string().nullable(),
  lackingAdequate: yup.string().nullable(),
  protectiveServiceInvestigation: yup.string().nullable(),
  homelessness: yup.string().nullable(),
  homelessnessInPast: yup.string().nullable(),
  birthMotherParity: yup.string().nullable(),
  abuseAffectingChild: yup.string().nullable(),
  socialSupport: yup.string().nullable(),
  comment: yup.string(),
});

export interface IntakeFamilyHistoryFormikType {
  race: string;
  ethnicity: string;
  motherRace: string;
  motherEthnicity: string;
  fatherRace: string;
  fatherEthnicity: string;
  education: string;
  educationYears: string;
  schoolCompleted: string;
  occupation: string;
  employeedBy: string;
  employerAddress: string;
  workPhone: string;
  jobType: string;
  jobTypeOther: string;
  primarySpokenLanguage: string;
  primarySpokenLanguageOther: string;
  primaryWrittenLanguage: string;
  primaryWrittenLanguageOther: string;
  parentsMaritalStatus: string;
  kinshipCare: string;
  withWhomChildLive: string;
  siblingNameId: string;
  school: string;
  grade: string;
  siblingType: string;
  pets: string;
  smoking: string;
  unsecuredWeapons: string;
  extendedFamily: string;
  compromisedImmuneSystem: string;
  familyMemberHistoryOther: string;
  parentalChronicIllness: string;
  affectingChild: string;
  siblingWithSEN: string;
  mothersEducationYear: string;
  mothersEducationYearCheck: boolean;
  povertyLevel: string;
  lackingAdequate: string;
  protectiveServiceInvestigation: string;
  homelessness: string;
  homelessnessInPast: string;
  birthMotherParity: string;
  abuseAffectingChild: string;
  socialSupport: string;
  comment: string;
}

interface UnsavedChangesWatcherProps {
  hasUnsavedChanges: boolean;
  onUnsavedChangesChange: (hasUnsavedChanges: boolean) => void;
}

const UnsavedChangesWatcher = ({
  hasUnsavedChanges,
  onUnsavedChangesChange,
}: UnsavedChangesWatcherProps) => {
  useLayoutEffect(() => {
    onUnsavedChangesChange(hasUnsavedChanges);
  }, [hasUnsavedChanges, onUnsavedChangesChange]);

  return null;
};

const IntakeFamilyHistoryInfo: React.FC<RoutingProps> = () => {
  const [intakeFamilyHistoryInfo, setIntakeFamilyHistoryInfo] =
    useState<IntakeFamilyHistoryInfoType>(IntakeFamilyHistoryInitialValues);

  const formikRef = useRef<FormikProps<IntakeFamilyHistoryInfoType>>(null);
  const clientId = localStorage.getItem('ClientId');

  const [raceValues, setRaceValues] = useState<OptionType[]>([]);
  const [ethnicityValues, setEthnicityValues] = useState<OptionType[]>([]);
  const [languageValues, setLanguageValues] = useState<OptionType[]>([]);

  const [showAlertDialog, setShowAlertDialog] = useState<boolean>(false);

  const [openModal, setOpenModal] = useState(false);

  const { toggleLoader } = React.useContext(LoaderContext) as LoaderContextType;

  const [toastrDefaultMessage, setToastrDefaultMessage] = React.useState('');
  const [toastrId, setToastrId] = useState<string>();
  const [successOrError, setSuccessOrError] = useState<ResponseType>('success');
  const permissions = useMultiplePermissions([
    'backend.clients',
    'backend.in_active_referrals',
  ]);
  const referralStatus = localStorage.getItem(REFERRAL_STATUS_KEY) ?? 'None';
  const [hasEditPermission, setHasEditPermission] = useState<boolean>(
    referralStatus === 'Inactive'
      ? permissions['backend.clients'].canEdit &&
          permissions['backend.in_active_referrals'].canEdit
      : permissions['backend.clients'].canEdit ||
          permissions['backend.in_active_referrals'].canEdit,
  );
  const [mothersEducationYearCheck, setMothersEducationYearCheck] =
    useState<boolean>(false);
  const parentRef = React.useRef<HTMLDivElement>(null);
  const { lookups } = useContext(LookUpContext);

  useEffect(() => {
    if (!hasEditPermission) {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Tab') {
          e.preventDefault();
        }
      };
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [hasEditPermission]);

  useEffect(() => {
    if (lookups === null) {
      return;
    }
    setRaceValues(() => {
      return lookups.race.map((r) => {
        return {
          label: r.description,
          id: r.code,
        };
      });
    });
    setEthnicityValues(() => {
      return lookups.ethnicity.map((e) => {
        return {
          label: e.description,
          id: e.code,
        };
      });
    });
    setLanguageValues(() => {
      return lookups.language.map((lang) => {
        return {
          label: lang.description,
          id: lang.code,
        };
      });
    });
    handleIntakeGetAPI();
  }, [lookups]);

  const getGuardianType = (guardianType: string): string => {
    if (lookups) {
      return (
        lookups?.guardianType?.find(
          (g) => g.code.toUpperCase() === guardianType.toUpperCase(),
        )?.description || '-'
      );
    }
    return '-';
  };

  const { handleUpdateUnsavedChanges } = useContext(UnSavedChangesContext);

  const handleIntakeGetAPI = async () => {
    if (clientId) {
      window.scrollTo(0, 0);
      toggleLoader(true);
      getIntakeFamilyHistoryInfoDetails(clientId)
        .then((response: IntakeFamilyHistoryInfoResponseType) => {
          if (response.isSigned) {
            setHasEditPermission(false);
          } else if (response.isCurrentlyHeld) {
            setHasEditPermission(false);
            showCancelToaster(response.heldBy);
          }
          setMothersEducationYearCheck(
            response.eics.mothersEducationYear === 'Unknown',
          );
          setIntakeFamilyHistoryInfo({
            ...intakeFamilyHistoryInfo,
            formHandleFlag: false,
            eics: {
              parent: response.eics.parent,
              race: response.eics.race.toString(),
              ethnicity: response.eics.ethnicity,
              primarySpokenLanguage:
                response.eics.primarySpokenLanguage.toString(),
              primarySpokenLanguageOther:
                response.eics.primarySpokenLanguageOther,
              primaryWrittenLanguage:
                response.eics.primaryWrittenLanguage.toString(),
              primaryWrittenLanguageOther:
                response.eics.primaryWrittenLanguageOther,
              mothersEducationYear: response.eics.mothersEducationYear,
              lackingAdequate: response.eics.lackingAdequate,
              homelessness: response.eics.homelessness,
              homelessnessInPast: response.eics.homelessnessInPast,
              protectiveServiceInvestigation:
                response.eics.protectiveServiceInvestigation,
              abuseAffectingChild: response.eics.abuseAffectingChild,
              parentalChronicIllness: response.eics.parentalChronicIllness,
              affectingChild: response.eics.affectingChild,
              socialSupport: response.eics.socialSupport,
              pets: response.eics.pets,
              smoking: response.eics.smoking,
              unsecuredWeapons: response.eics.unsecuredWeapons,
            },
            ecoMap: {
              whoWatchesChild: response.ecoMap.whoWatchesChild,
              receivingFinancialSupport:
                response.ecoMap.receivingFinancialSupport,
              receivingFinancialSupportDesc:
                response.ecoMap.receivingFinancialSupportDesc,
              additionalTherapies: response.ecoMap.additionalTherapies,
              additionalTherapiesDesc: response.ecoMap.additionalTherapiesDesc,
              livesInHomeDesc: response.ecoMap.livesInHomeDesc,
              familyTogetherDesc: response.ecoMap.familyTogetherDesc,
              spiritualGroups: response.ecoMap.spiritualGroups,
              spiritualGroupsDesc: response.ecoMap.spiritualGroupsDesc,
              importantPeopleDesc: response.ecoMap.importantPeopleDesc,
              emergencyCallDesc: response.ecoMap.emergencyCallDesc,
              anyoneImportantDesc: response.ecoMap.anyoneImportantDesc,
              workType: response.ecoMap.workType,
              workTypeDesc: response.ecoMap.workTypeDesc,
            },
            extendedFamilyDesc: response.extendedFamilyDesc,
            familyMedicalHistoryDesc: response.familyMedicalHistoryDesc,
            fatherEthnicity: response.fatherEthnicity,
            fatherRace: response.fatherRace,
            motherEthnicity: response.motherEthnicity,
            motherRace: response.motherRace,
            weakenedImmuneSystem: response.weakenedImmuneSystem,
            weakenedImmuneSystemDesc: response.weakenedImmuneSystemDesc,
            involvedRegularlyInChild: response.involvedRegularlyInChild,
            lastSchoolGradeDesc: response.lastSchoolGradeDesc,
            education: response.education,
            occupation: response.occupation,
            employeedBy: response.employeedBy,
            employerAddress: response.employerAddress,
            workPhone: response.workPhone,
            parentsMaritalStatus: response.parentsMaritalStatus,
            kinshipCare: response.kinshipCare,
            comment: response.comment,
          });

          toggleLoader(false);
        })
        .catch((error) => {
          toggleLoader(false);
          setSuccessOrError('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            setToastrId(error);
            setToastrDefaultMessage(error);
          }
        });
    }
  };

  const handleFormSubmit = useCallback(
    debounce(() => {
      updateWithDebounce();
    }, 500),
    [],
  );

  const updateWithDebounce = async () => {
    // Very very important
    await formikRef.current?.submitForm();
    await formikRef.current?.validateForm();
    formikRef.current?.setSubmitting(false);
    // Very very important

    if (clientId) {
      if (formikRef?.current?.isValid) {
        const params: IntakeFamilyHistoryInfoResponseType = {
          eics: {
            abuseAffectingChild:
              formikRef.current.values.eics.abuseAffectingChild,
            affectingChild: formikRef.current.values.eics.affectingChild,
            ethnicity: formikRef.current.values.eics.ethnicity,
            homelessness: formikRef.current.values.eics.homelessness,
            homelessnessInPast:
              formikRef.current.values.eics.homelessnessInPast,
            lackingAdequate: formikRef.current.values.eics.lackingAdequate,
            mothersEducationYear:
              formikRef.current.values.eics.mothersEducationYear,
            parent: formikRef.current.values.eics.parent,
            parentalChronicIllness:
              formikRef.current.values.eics.parentalChronicIllness,
            pets: formikRef.current.values.eics.pets,
            primarySpokenLanguage:
              formikRef.current.values.eics.primarySpokenLanguage,
            primarySpokenLanguageOther:
              formikRef.current.values.eics.primarySpokenLanguageOther,
            primaryWrittenLanguage:
              formikRef.current.values.eics.primaryWrittenLanguage,
            primaryWrittenLanguageOther:
              formikRef.current.values.eics.primaryWrittenLanguageOther,
            protectiveServiceInvestigation:
              formikRef.current.values.eics.protectiveServiceInvestigation,
            race: formikRef.current.values.eics.race,
            smoking: formikRef.current.values.eics.smoking,
            socialSupport: formikRef.current.values.eics.socialSupport,
            unsecuredWeapons: formikRef.current.values.eics.unsecuredWeapons,
          },
          ecoMap: {
            additionalTherapies:
              formikRef.current.values.ecoMap.additionalTherapies,
            additionalTherapiesDesc:
              formikRef.current.values.ecoMap.additionalTherapiesDesc,
            importantPeopleDesc:
              formikRef.current.values.ecoMap.importantPeopleDesc,
            livesInHomeDesc: formikRef.current.values.ecoMap.livesInHomeDesc,
            anyoneImportantDesc:
              formikRef.current.values.ecoMap.anyoneImportantDesc,
            emergencyCallDesc:
              formikRef.current.values.ecoMap.emergencyCallDesc,
            familyTogetherDesc:
              formikRef.current.values.ecoMap.familyTogetherDesc,
            receivingFinancialSupport:
              formikRef.current.values.ecoMap.receivingFinancialSupport,
            receivingFinancialSupportDesc:
              formikRef.current.values.ecoMap.receivingFinancialSupportDesc,
            spiritualGroups: formikRef.current.values.ecoMap.spiritualGroups,
            spiritualGroupsDesc:
              formikRef.current.values.ecoMap.spiritualGroupsDesc,
            whoWatchesChild: formikRef.current.values.ecoMap.whoWatchesChild,
            workType: formikRef.current.values.ecoMap.workType,
            workTypeDesc: formikRef.current.values.ecoMap.workTypeDesc,
          },
          fatherEthnicity: formikRef.current.values.fatherEthnicity,
          fatherRace: formikRef.current.values.fatherRace,
          motherEthnicity: formikRef.current.values.motherEthnicity,
          motherRace: formikRef.current.values.motherRace,
          education: formikRef.current.values.education,
          employeedBy: formikRef.current.values.employeedBy,
          employerAddress: formikRef.current.values.employerAddress,
          extendedFamilyDesc: formikRef.current.values.extendedFamilyDesc,
          familyMedicalHistoryDesc:
            formikRef.current.values.familyMedicalHistoryDesc,
          involvedRegularlyInChild:
            formikRef.current.values.involvedRegularlyInChild,
          kinshipCare: formikRef.current.values.kinshipCare,
          lastSchoolGradeDesc: formikRef.current.values.lastSchoolGradeDesc,
          occupation: formikRef.current.values.occupation,
          parentsMaritalStatus: formikRef.current.values.parentsMaritalStatus,
          weakenedImmuneSystem: formikRef.current.values.weakenedImmuneSystem,
          weakenedImmuneSystemDesc:
            formikRef.current.values.weakenedImmuneSystemDesc,
          workPhone: formikRef.current.values.workPhone,
          comment: formikRef.current.values.comment,
        };
        toggleLoader(true);
        putIntakeFamilyHistoryInfo(clientId, params)
          .then(async (response) => {
            if (response) {
              setSuccessOrError('success');
              setToastrId('Intake.successMsg');
              setToastrDefaultMessage('Intake updated successfully');
              await formikRef.current?.setFieldValue('formHandleFlag', false);
              setTimeout(() => {
                toggleLoader(false);
              }, 1000);

              handleIntakeGetAPI();
            }
          })
          .catch((error) => {
            toggleLoader(false);
            setSuccessOrError('error');
            if (isCustomError(error)) {
              const apiError = error as ApiError;
              setToastrId(apiError.id);
              setToastrDefaultMessage(apiError.message);
            } else {
              setToastrId(error);
              setToastrDefaultMessage(error);
            }
          });
      }
    }
  };

  const handleCancellationFlow = () => {
    if (_.isEqual(intakeFamilyHistoryInfo, formikRef.current?.values)) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      {toastrId && (
        <SnackBarComponent
          open={toastrId !== undefined}
          handleClose={() => {
            setToastrId(undefined);
          }}
          labelId={toastrId}
          defaultMessageId={toastrDefaultMessage}
          successOrError={successOrError}
          snackbarProps={{
            top: '60px !important',
          }}
        />
      )}
      <Box
        ref={parentRef}
        style={{
          pointerEvents: hasEditPermission ? 'auto' : 'none',
          opacity: hasEditPermission ? 'unset' : '0.8',
        }}
      >
        <Card className="formCardview gray3 borderRadius4 mb-md p-sm mt-md">
          <ModalPopup
            open={showAlertDialog}
            description="duplicateIntakeTeamWarningMessage"
            onOk={() => {
              setShowAlertDialog(false);
            }}
            labelId2="Clientpage.Okbtn"
            positiveActionLabel="Ok"
          />
          <Formik
            initialValues={intakeFamilyHistoryInfo}
            innerRef={formikRef}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={() => {}}
          >
            {({ values, setFieldValue, errors, touched }) => {
              return (
                <Box component="div">
                  <UnsavedChangesWatcher
                    hasUnsavedChanges={
                      !_.isEqual(intakeFamilyHistoryInfo, values)
                    }
                    onUnsavedChangesChange={handleUpdateUnsavedChanges}
                  />
                  <Box
                    component="div"
                    className="p-sm gray3 borderRadius4"
                    sx={{
                      border: '1px solid #00C6B8',
                    }}
                  >
                    <MediumTypography
                      labelid="IntakeFamilyHistory.FamilyCharacteristicsTitle"
                      defaultlabel="Family Characteristics"
                      fontSize="16px"
                      fontweight={600}
                      textColor="#2A4241"
                    />
                    <Box
                      component="div"
                      className="flex__ align__items__center mt-md"
                    >
                      <KeyValueComponent
                        data={[
                          {
                            id: 'ProgressNote.Name',
                            labelid: 'ProgressNote.Name',
                            defaultLabel: 'Name:',
                            value: values.eics.parent.name
                              ? values.eics.parent.name
                              : '-',
                          },
                          {
                            id: 'Facesheet.relationship',
                            labelid: 'Facesheet.relationship',
                            defaultLabel: 'Guardian Type:',
                            value: values.eics.parent.relationshipToClient
                              ? getGuardianType(
                                  values.eics.parent.relationshipToClient,
                                )
                              : '-',
                          },
                          {
                            id: 'ConsentForms.programPhone',
                            labelid: 'ConsentForms.programPhone',
                            defaultLabel: 'Phone:',
                            value: values.eics.parent.phoneNumber
                              ? values.eics.parent.phoneNumber
                              : '-',
                          },
                          {
                            id: 'ConsentForms.clientAddress',
                            labelid: 'ConsentForms.clientAddress',
                            defaultLabel: 'Address:',
                            value: values.eics.parent.address
                              ? values.eics.parent.address
                              : '-',
                          },
                        ]}
                      />
                    </Box>
                    <Box
                      component="div"
                      className="flex__ align__items__center mt-md"
                    >
                      <MediumTypography
                        labelid="IntakeFamilyHistory.MotherRaceTitle"
                        defaultlabel="Parent/Guardian"
                        fontSize="14px"
                        fontweight={600}
                        textColor="#00C6B8"
                      />
                    </Box>

                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'24px'}
                      className="mt-md mb-md"
                    >
                      <Grid item xs={4.5} lg={4.5} className="multisearchHgt">
                        <MultipleAutocompleteSearch
                          labelId="IntakeFamilyHistory.RacePlaceholder"
                          defaultId="Race *"
                          data={raceValues}
                          type="string"
                          onSelectItem={(value: OptionType[] | null) => {
                            if (value) {
                              const selectedRaceIds = value.map((r) => r.id);
                              setFieldValue(
                                'motherRace',
                                selectedRaceIds.toString(),
                              );
                            }
                          }}
                          disableLabel={true}
                          optionHintId={'No Race found'}
                          sxProps={{
                            [`& .${autocompleteClasses.popupIndicator}`]: {
                              transform: 'none',
                              marginTop: '2px',
                            },
                            backgroundColor: '#fff',
                          }}
                          value={values.motherRace
                            .split(',') // Split the string by comma
                            .map((r) => ({
                              id: r,
                              label:
                                raceValues.find(
                                  (raceValue) => raceValue.id === r,
                                )?.label || '', // Set label to empty string if not found
                            }))
                            .filter(
                              (
                                option,
                              ): option is { id: string; label: string } =>
                                option.label !== '', // Filter out options with empty labels
                            )}
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                      <Grid item xs={4.5} lg={4.5}>
                        <DropdownComponent
                          names={ethnicityValues}
                          labelid={'IntakeFamilyHistory.EthnicityPlaceholder'}
                          value={values.motherEthnicity}
                          defaultlabelid="Ethnicity *"
                          handleChange={(e) => {
                            setFieldValue('motherEthnicity', e);
                          }}
                          disabled={!hasEditPermission}
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>

                    <Box
                      component="div"
                      className="flex__ align__items__center mt-md"
                    >
                      <MediumTypography
                        labelid="IntakeFamilyHistory.FatherRaceTitle"
                        defaultlabel="Parent/Guardian"
                        fontSize="14px"
                        fontweight={600}
                        textColor="#00C6B8"
                      />
                      <MediumTypography
                        labelid="IntakeFamilyHistory.FatherRaceTitle.ifMoreThanOne"
                        defaultlabel="Parent/Guardian"
                        fontSize="14px"
                        fontweight={600}
                        textColor="#00C6B8"
                      />
                    </Box>

                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'24px'}
                      className="mt-md mb-md"
                    >
                      <Grid item xs={4.5} lg={4.5} className="multisearchHgt">
                        <MultipleAutocompleteSearch
                          labelId="IntakeFamilyHistory.RacePlaceholder"
                          defaultId="Race *"
                          data={raceValues}
                          type="string"
                          onSelectItem={(value: OptionType[] | null) => {
                            if (value) {
                              const selectedRaceIds = value.map((r) => r.id);
                              setFieldValue(
                                'fatherRace',
                                selectedRaceIds.toString(),
                              );
                            }
                          }}
                          disableLabel={true}
                          optionHintId={'No Race found'}
                          sxProps={{
                            [`& .${autocompleteClasses.popupIndicator}`]: {
                              transform: 'none',
                              marginTop: '2px',
                            },
                            backgroundColor: '#fff',
                          }}
                          value={values.fatherRace
                            .split(',') // Split the string by comma
                            .map((r) => ({
                              id: r,
                              label:
                                raceValues.find(
                                  (raceValue) => raceValue.id === r,
                                )?.label || '', // Set label to empty string if not found
                            }))
                            .filter(
                              (
                                option,
                              ): option is { id: string; label: string } =>
                                option.label !== '', // Filter out options with empty labels
                            )}
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                      <Grid item xs={4.5} lg={4.5}>
                        <DropdownComponent
                          names={ethnicityValues}
                          labelid={'IntakeFamilyHistory.EthnicityPlaceholder'}
                          value={values.fatherEthnicity}
                          defaultlabelid="Ethnicity *"
                          handleChange={(e) => {
                            setFieldValue('fatherEthnicity', e);
                          }}
                          disabled={!hasEditPermission}
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>

                    <Box
                      component="div"
                      className="flex__ align__items__center mt-md"
                    >
                      <MediumTypography
                        labelid="IntakeFamilyHistory.ClientsRaceTitle"
                        defaultlabel="Client"
                        fontSize="14px"
                        fontweight={600}
                        textColor="#00C6B8"
                      />
                    </Box>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'24px'}
                      className="mt-md mb-md"
                    >
                      <Grid item xs={4.5} lg={4.5} className="multisearchHgt">
                        <MultipleAutocompleteSearch
                          labelId="IntakeFamilyHistory.RacePlaceholder"
                          defaultId="Race *"
                          data={raceValues}
                          type="string"
                          onSelectItem={(value: OptionType[] | null) => {
                            if (value) {
                              const selectedRaceIds = value.map((r) => r.id);
                              setFieldValue(
                                'eics.race',
                                selectedRaceIds.toString(),
                              );
                            }
                          }}
                          disableLabel={true}
                          optionHintId={'No Race found'}
                          sxProps={{
                            [`& .${autocompleteClasses.popupIndicator}`]: {
                              transform: 'none',
                              marginTop: '2px',
                            },
                            backgroundColor: '#fff',
                          }}
                          value={values.eics.race
                            .split(',') // Split the string by comma
                            .map((r) => ({
                              id: r,
                              label:
                                raceValues.find(
                                  (raceValue) => raceValue.id === r,
                                )?.label || '', // Set label to empty string if not found
                            }))
                            .filter(
                              (
                                option,
                              ): option is { id: string; label: string } =>
                                option.label !== '', // Filter out options with empty labels
                            )}
                          disabled
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                      <Grid item xs={4.5} lg={4.5}>
                        <DropdownComponent
                          names={ethnicityValues}
                          labelid={'IntakeFamilyHistory.EthnicityPlaceholder'}
                          value={values.eics.ethnicity}
                          defaultlabelid="Ethnicity *"
                          handleChange={(e) => {
                            setFieldValue('eics.ethnicity', e);
                          }}
                          disabled
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'24px'}
                      className="mt-md mb-md"
                    >
                      <Grid item xs={9}>
                        <Textinput
                          name="schoolCompleted"
                          labelid="IntakeFamilyHistory.schoolCompleted"
                          defaultlabelid="What was the last grade of school you completed?"
                          Value={values.lastSchoolGradeDesc}
                          handlechange={(text: string) => {
                            setFieldValue('lastSchoolGradeDesc', text);
                          }}
                          inputProps={{
                            maxLength: 100,
                          }}
                          sxProps={{
                            backgroundColor: 'white',
                          }}
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>
                    <Box
                      component="div"
                      className="flex__ align__items__center mt-md"
                    >
                      <MediumTypography
                        labelid="IntakeFamilyHistory.Qualification"
                        defaultlabel="Education Completed"
                        fontSize="14px"
                        fontweight={600}
                        textColor="#00C6B8"
                      />
                    </Box>
                    <Box component="div" className="mt-md">
                      <CustomRadioButton
                        data={QualificationJsonData}
                        value={values.education}
                        onSelectItem={(value) =>
                          setFieldValue('education', value)
                        }
                      />
                    </Box>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'24px'}
                      className="mt-md mb-md"
                    >
                      <Grid item xs={9}>
                        <Textinput
                          name="occupation"
                          labelid="IntakeFamilyHistory.occupation"
                          defaultlabelid="Occupation"
                          Value={values.occupation}
                          handlechange={(text: string) => {
                            setFieldValue('occupation', text);
                          }}
                          inputProps={{
                            maxLength: 100,
                          }}
                          sxProps={{
                            backgroundColor: 'white',
                          }}
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                        {errors.occupation && touched.occupation && (
                          <MediumTypography
                            labelid={errors.occupation}
                            defaultlabel="Is Required"
                            className="errorText-md"
                          />
                        )}
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'24px'}
                      className="mt-md"
                    >
                      <Grid item xs={9}>
                        <Textinput
                          name="employeedBy"
                          labelid="IntakeFamilyHistory.employedBy"
                          defaultlabelid="Employed By"
                          Value={values.employeedBy}
                          handlechange={(text: string) => {
                            setFieldValue('employeedBy', text);
                          }}
                          inputProps={{
                            maxLength: 100,
                          }}
                          sxProps={{
                            backgroundColor: 'white',
                          }}
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                        {errors.employeedBy && touched.employeedBy && (
                          <MediumTypography
                            labelid={errors.employeedBy}
                            defaultlabel="Is Required"
                            className="errorText-md"
                          />
                        )}
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'24px'}
                      className="mt-sm"
                    >
                      <Grid item xs={9}>
                        <CommentTextbox
                          Value={values.employerAddress}
                          placeholder="Employer Address"
                          name="employerAddress"
                          maxLength={300}
                          handlechange={(e) => {
                            setFieldValue('employerAddress', e);
                          }}
                          placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                        {errors.employerAddress && touched.employerAddress && (
                          <MediumTypography
                            labelid={errors.employerAddress}
                            defaultlabel="Employer Address is Required"
                            className="errorText-md"
                          />
                        )}
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'24px'}
                      className="mt-sm mb-md"
                    >
                      <Grid item xs={4.5}>
                        <Textinput
                          name="workPhone"
                          labelid="parentGuardian.workPhoneNumber"
                          defaultlabelid="Work Phone Number"
                          Value={values.workPhone}
                          handlechange={(text: string) => {
                            const validatedNumber = formatPhoneNumber(text);
                            setFieldValue('workPhone', validatedNumber);
                          }}
                          inputProps={{
                            maxLength: 12,
                            pattren: ['0-9'],
                          }}
                          sxProps={{
                            backgroundColor: 'white',
                          }}
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                        {errors.workPhone && touched.workPhone && (
                          <MediumTypography
                            labelid={errors.workPhone}
                            defaultlabel="Phone Number is Required"
                            className="errorText-md"
                          />
                        )}
                      </Grid>
                    </Grid>
                    <Box component="div">
                      <MediumTypography
                        className="mr-lg"
                        labelid="IntakeFamilyHistory.MoreInfo"
                        defaultlabel="More Info"
                      />
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-md"
                      >
                        <Grid item xs={9} lg={9}>
                          <CustomRadioButton
                            data={JobTypeJsonData}
                            value={values.ecoMap.workType}
                            onSelectItem={(value) => {
                              if (value) {
                                if (values.ecoMap.workType !== 'Other') {
                                  setFieldValue('ecoMap.workTypeDesc', '');
                                }
                                setFieldValue('ecoMap.workType', value);
                              }
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Box>

                    {values.ecoMap.workType === 'Other' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'24px'}
                        className="mt-md mb-md"
                      >
                        <Grid item xs={9}>
                          <Textinput
                            name="jobTypeOther"
                            labelid="otherText"
                            defaultlabelid="Other"
                            Value={values.ecoMap.workTypeDesc}
                            handlechange={(text: string) => {
                              setFieldValue('ecoMap.workTypeDesc', text);
                            }}
                            inputProps={{
                              maxLength: 100,
                            }}
                            sxProps={{
                              backgroundColor: 'white',
                            }}
                            placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}

                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'24px'}
                      rowGap={'24px'}
                      className="mt-md mb-lg"
                    >
                      <Grid item xs={4.5} lg={4.5}>
                        <DropdownComponent
                          names={languageValues}
                          labelid={'Clientpage.primarySpokenLanguage'}
                          value={values.eics.primarySpokenLanguage}
                          defaultlabelid="Primary Spoken Language"
                          handleChange={(e) => {
                            setFieldValue('eics.primarySpokenLanguage', e);
                          }}
                          disabled={!hasEditPermission}
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                      <Grid item xs={4.5} lg={4.5}>
                        <DropdownComponent
                          names={languageValues}
                          labelid={'Clientpage.PrimaryWritten'}
                          value={values.eics.primaryWrittenLanguage}
                          defaultlabelid="Primary Written Language"
                          handleChange={(e) => {
                            setFieldValue('eics.primaryWrittenLanguage', e);
                          }}
                          disabled={!hasEditPermission}
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                      {/* <Grid
                        container
                        direction={'row'}
                        columnSpacing={'24px'}
                        className="mt-md mb-sm"
                      > */}
                      {values.eics.primarySpokenLanguage.includes('OTHER') && (
                        <>
                          <Grid item xs={4.5} lg={4.5}>
                            <Textinput
                              name="primarySpokenLanguageOther"
                              labelid="otherText"
                              defaultlabelid="Other Spoken Language"
                              Value={values.eics.primarySpokenLanguageOther}
                              handlechange={(text: string) => {
                                setFieldValue(
                                  'eics.primarySpokenLanguageOther',
                                  text,
                                );
                              }}
                              inputProps={{
                                maxLength: 100,
                              }}
                              sxProps={{
                                backgroundColor: 'white',
                              }}
                              disabled
                              placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                            />
                          </Grid>
                          {!values.eics.primarySpokenLanguage.includes(
                            'OTHER',
                          ) && <Grid item xs={4.5} lg={4.5}></Grid>}
                        </>
                      )}

                      {values.eics.primaryWrittenLanguage.includes('OTHER') && (
                        <>
                          {!values.eics.primarySpokenLanguage.includes(
                            'OTHER',
                          ) && <Grid item xs={4.5} lg={4.5}></Grid>}
                          <Grid item xs={4.5} lg={4.5}>
                            <Textinput
                              name="primaryWrittenLanguageOther"
                              labelid="otherText"
                              defaultlabelid="Other Written Language"
                              Value={values.eics.primaryWrittenLanguageOther}
                              handlechange={(text: string) => {
                                setFieldValue(
                                  'eics.primaryWrittenLanguageOther',
                                  text,
                                );
                              }}
                              inputProps={{
                                maxLength: 100,
                              }}
                              sxProps={{
                                backgroundColor: 'white',
                              }}
                              disabled
                              placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                            />
                          </Grid>
                        </>
                      )}
                      {/* </Grid> */}
                      <Grid item xs={4.5} lg={4.5}>
                        <DropdownComponent
                          names={parentsMaritalStatus}
                          labelid={'IntakeFamilyHistory.ParentMaritalStatus'}
                          value={values.parentsMaritalStatus}
                          defaultlabelid="Parent(s) marital status`x"
                          handleChange={(e) => {
                            setFieldValue('parentsMaritalStatus', e);
                          }}
                          disabled={!hasEditPermission}
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>

                    <Box
                      component="div"
                      className="flex__ align__items__center mt-md"
                    >
                      <Box>
                        <MediumTypography
                          labelid="IntakeFamilyHistory.FosterParents"
                          defaultlabel="Foster Parents - "
                          fontSize="14px"
                          fontweight={600}
                          textColor="#00C6B8"
                          sxProps={{ pr: 0.5 }}
                        />
                      </Box>
                      <Box>
                        <MediumTypography
                          labelid="IntakeFamilyHistory.InfoNote"
                          defaultlabel="Enter this only if the child has Foster parents"
                          fontSize="10px"
                        />
                      </Box>
                    </Box>

                    <Box className="mt-sm">
                      <MediumTypography
                        className="mr-lg"
                        labelid="IntakeFamilyHistory.kinshipCare"
                        defaultlabel="Is this kinship care ?"
                      />
                      <CustomRadioButton
                        data={IntakeRadioData}
                        value={values.kinshipCare}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('kinshipCare', value);
                          }
                        }}
                      />
                      {errors.kinshipCare && touched.kinshipCare && (
                        <MediumTypography
                          labelid={errors.kinshipCare}
                          defaultlabel="kinshipCare is Required"
                          className="errorText-md"
                        />
                      )}
                    </Box>
                    <Box className="mt-sm">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeFamilyHistory.mothersEducationYear"
                          defaultlabel="Biological mother’s years of formal education?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                        className="mt-sm mb-sm"
                      >
                        <Textinput
                          name="mothersEducationYear"
                          labelid=""
                          defaultlabelid=""
                          Value={values.eics.mothersEducationYear}
                          handlechange={(text: string) => {
                            const regex = /^\d+$/;
                            if (regex.test(text) || text === '') {
                              setFieldValue('eics.mothersEducationYear', text);
                            }
                          }}
                          inputProps={{
                            maxLength: 2,
                          }}
                          sxProps={{
                            backgroundColor: 'white',
                            width: '30%',
                          }}
                          className="mr-md"
                          placeholderOnfloatBackgroundColor="var(--thom-mono-gray3-bg)"
                          disabled={mothersEducationYearCheck}
                        />
                        <CheckBoxComponent
                          CheckHandleChange={(e) => {
                            if (e.target.checked) {
                              setFieldValue(
                                'eics.mothersEducationYear',
                                'Unknown',
                              );
                              setMothersEducationYearCheck(true);
                            } else {
                              setMothersEducationYearCheck(false);
                              setFieldValue('eics.mothersEducationYear', '');
                            }
                          }}
                          ischecked={mothersEducationYearCheck}
                          labelid="Intake.RadioLabelC"
                          defaultlabelid="Unknown"
                        />
                      </Box>
                    </Box>
                    <MediumTypography
                      labelid="IntakeFamilyHistory.socialSupports"
                      defaultlabel="Social Supports"
                      fontSize="16px"
                      fontweight={600}
                      textColor="#2A4241"
                    />
                    <Box className="mt-sm">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeFamilyHistory.lackingAdequate"
                          defaultlabel="Lacking adequate food or clothing ?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.lackingAdequate}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.lackingAdequate', value);
                          }
                        }}
                      />
                    </Box>
                    <Box className="mt-sm">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeFamilyHistory.homelessness"
                          defaultlabel="Homelessness?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.homelessness}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.homelessness', value);
                          }
                        }}
                      />
                    </Box>
                    <Box className="mt-sm">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeFamilyHistory.homelessnessInPast"
                          defaultlabel="Homeless in the past 12 months?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.homelessnessInPast}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.homelessnessInPast', value);
                          }
                        }}
                      />
                    </Box>
                    <Box className="mt-sm">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeFamilyHistory.protectiveService"
                          defaultlabel="Open/Confirmed protective service investigation ?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.protectiveServiceInvestigation}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue(
                              'eics.protectiveServiceInvestigation',
                              value,
                            );
                          }
                        }}
                      />
                    </Box>
                    <Box className="mt-sm">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeFamilyHistory.abuse"
                          defaultlabel="Abuse (physical or emotional) affecting child ?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.abuseAffectingChild}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.abuseAffectingChild', value);
                          }
                        }}
                      />
                    </Box>
                    <Box className="mt-sm">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeFamilyHistory.parentalChronicIllness"
                          defaultlabel="Parental chronic illness or disability that affects caregiving ability ?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.parentalChronicIllness}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.parentalChronicIllness', value);
                          }
                        }}
                      />
                    </Box>
                    <Box className="mt-sm">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeFamilyHistory.affectingChild"
                          defaultlabel="Substance abuse affecting child ?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.affectingChild}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.affectingChild', value);
                          }
                        }}
                      />
                    </Box>
                    <Box className="mt-sm">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeFamilyHistory.socialSupport"
                          defaultlabel="Family lacking social supports ?"
                        />
                        <MediumTypography
                          labelid="Intake.Eics"
                          defaultlabel="(EICS)"
                          sxProps={{ fontStyle: 'italic' }}
                          className="ml-xs"
                        />
                      </Box>
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.eics.socialSupport}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.socialSupport', value);
                          }
                        }}
                      />
                    </Box>
                    <Box className="mt-sm">
                      <MediumTypography
                        labelid="IntakeFamilyHistory.whoWatches"
                        defaultlabel="Who watches this child when you are doing activities, such as work or school?"
                      />
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.ecoMap.whoWatchesChild}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={4}
                            handlechange={(e) => {
                              setFieldValue('ecoMap.whoWatchesChild', e);
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box className="mt-sm">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.receiveFinancialSupport"
                        defaultlabel="Is your family receiving any financial supports at this time?"
                        className="mr-md"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.ecoMap.receivingFinancialSupport}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue(
                              'ecoMap.receivingFinancialSupport',
                              value,
                            );
                            setFieldValue(
                              'ecoMap.receivingFinancialSupportDesc',
                              '',
                            );
                          }
                        }}
                      />
                    </Box>
                    {values.ecoMap.receivingFinancialSupport === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.ecoMap.receivingFinancialSupportDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={4}
                            handlechange={(e) => {
                              setFieldValue(
                                'ecoMap.receivingFinancialSupportDesc',
                                e,
                              );
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-sm">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.anyAdditionalTherapiesOrEmotionalSupports"
                        defaultlabel="Are you involved in any additional therapies or emotional supports?"
                        className="mr-md"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.ecoMap.additionalTherapies}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('ecoMap.additionalTherapies', value);
                            setFieldValue('ecoMap.additionalTherapiesDesc', '');
                          }
                        }}
                      />
                    </Box>
                    {values.ecoMap.additionalTherapies === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.ecoMap.additionalTherapiesDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={4}
                            handlechange={(e) => {
                              setFieldValue(
                                'ecoMap.additionalTherapiesDesc',
                                e,
                              );
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-sm">
                      <MediumTypography
                        labelid="IntakeFamilyHistory.whoLivesInThisHome"
                        defaultlabel="Who lives in this home?"
                      />
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.ecoMap.livesInHomeDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={4}
                            handlechange={(e) => {
                              setFieldValue('ecoMap.livesInHomeDesc', e);
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box className="mt-sm">
                      <MediumTypography
                        labelid="IntakeFamilyHistory.whatDoesYourFamilyLikeToDoTogether"
                        defaultlabel="What does your family like to do together?"
                      />
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.ecoMap.familyTogetherDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={4}
                            handlechange={(e) => {
                              setFieldValue('ecoMap.familyTogetherDesc', e);
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box className="mt-sm">
                      <MediumTypography
                        labelid="IntakeCurrentHealth.doYouParticipateInAnyReligiousOrSpiritualGroups"
                        defaultlabel="Do you participate in any religious or spiritual groups?"
                        className="mr-md"
                      />
                      <CustomRadioButton
                        data={EICSRadioData}
                        value={values.ecoMap.spiritualGroups}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('ecoMap.spiritualGroups', value);
                            setFieldValue('ecoMap.spiritualGroupsDesc', '');
                          }
                        }}
                      />
                    </Box>
                    {values.ecoMap.spiritualGroups === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.ecoMap.spiritualGroupsDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={4}
                            handlechange={(e) => {
                              setFieldValue('ecoMap.spiritualGroupsDesc', e);
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-sm">
                      <MediumTypography
                        labelid="IntakeFamilyHistory.whoAreTheMostImportantPeopleInThisChildsLife"
                        defaultlabel="Who are the most important people in this child’s life?"
                      />
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.ecoMap.importantPeopleDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={4}
                            handlechange={(e) => {
                              setFieldValue('ecoMap.importantPeopleDesc', e);
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box className="mt-sm">
                      <MediumTypography
                        labelid="IntakeFamilyHistory.ifThereWasAnEmergencyWhoWouldYouCall"
                        defaultlabel="If there was an emergency, who would you call?"
                      />
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.ecoMap.emergencyCallDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={4}
                            handlechange={(e) => {
                              setFieldValue('ecoMap.emergencyCallDesc', e);
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box className="mt-sm">
                      <MediumTypography
                        labelid="IntakeFamilyHistory.anyoneElseImportantToYouThatLivesInTheArea"
                        defaultlabel="Do you have family or anyone else important to you that lives in the area?"
                      />
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.ecoMap.anyoneImportantDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={4}
                            handlechange={(e) => {
                              setFieldValue('ecoMap.anyoneImportantDesc', e);
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box className="mt-sm">
                      <MediumTypography
                        labelid="IntakeFamilyHistory.extendedFamilySupportiveAndOfHelpToYou"
                        defaultlabel="Tell me about your extended family. Are they supportive and of help to you? "
                      />
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.extendedFamilyDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={4}
                            handlechange={(e) => {
                              setFieldValue('extendedFamilyDesc', e);
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box className="mt-sm">
                      <MediumTypography
                        labelid="IntakeFamilyHistory.involvedRegularlyInThisChildsLife"
                        defaultlabel="Who else is involved regularly in this child’s life?"
                      />
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.involvedRegularlyInChild}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={4}
                            handlechange={(e) => {
                              setFieldValue('involvedRegularlyInChild', e);
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box className="mt-sm">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeFamilyHistory.anyPets"
                          defaultlabel="Any pets?"
                        />
                      </Box>
                      <CustomRadioButton
                        data={IntakeRadioData}
                        value={values.eics.pets}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.pets', value);
                          }
                        }}
                        disable
                      />
                    </Box>

                    <Box className="mt-sm">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeFamilyHistory.smokePlaceholder"
                          defaultlabel="Does anyone smoke inside or outside the home?"
                        />
                      </Box>
                      <CustomRadioButton
                        data={IntakeRadioData}
                        value={values.eics.smoking}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.smoking', value);
                          }
                        }}
                        disable
                      />
                    </Box>

                    <Box className="mt-sm">
                      <Box className="flex__">
                        <MediumTypography
                          labelid="IntakeFamilyHistory.weapons"
                          defaultlabel="Guns/Weapons/Firearms in the home?"
                        />
                      </Box>
                      <CustomRadioButton
                        data={IntakeRadioData}
                        value={values.eics.unsecuredWeapons}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('eics.unsecuredWeapons', value);
                          }
                        }}
                        disable
                      />
                    </Box>
                    <MediumTypography
                      labelid="IntakeFamilyHistory.additionalFamilyInformation"
                      defaultlabel="Additional Family Information"
                      fontSize="16px"
                      fontweight={600}
                      textColor="#2A4241"
                      className="mt-sm"
                    />
                    <Box className="mt-sm">
                      <MediumTypography
                        className="mr-lg"
                        labelid="IntakeFamilyHistroy.immunizationExplain"
                        defaultlabel="Do any members of your household have a weakened or compromised immune system, OR > 65 OR chronic health condition?"
                      />
                      <CustomRadioButton
                        data={IntakeRadioData}
                        value={values.weakenedImmuneSystem}
                        onSelectItem={(value) => {
                          if (value) {
                            setFieldValue('weakenedImmuneSystem', value);
                            setFieldValue('weakenedImmuneSystemDesc', '');
                          }
                        }}
                      />
                    </Box>
                    {values.weakenedImmuneSystem === 'Yes' && (
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.weakenedImmuneSystemDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={4}
                            handlechange={(e) => {
                              setFieldValue('weakenedImmuneSystemDesc', e);
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Box className="mt-sm">
                      <MediumTypography
                        className="mr-lg"
                        labelid="IntakeFamilyHistroy.likeToShare"
                        defaultlabel="Is there any family medical history or educational needs that you would like to share?"
                      />
                      <Grid
                        container
                        direction={'row'}
                        columnSpacing={'40px'}
                        className="mt-md mb-lg"
                      >
                        {' '}
                        <Grid item xs={9} lg={9}>
                          <CommentTextbox
                            Value={values.familyMedicalHistoryDesc}
                            placeholder="Comments"
                            name="immunizationExplain"
                            maxLength={2000}
                            rows={4}
                            handlechange={(e) => {
                              setFieldValue('familyMedicalHistoryDesc', e);
                            }}
                            placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                          />
                        </Grid>
                      </Grid>
                    </Box>

                    <Box className="mt-md">
                      <MediumTypography
                        labelid="Intake.additionalCommentsTitle"
                        defaultlabel="Additional Comments"
                        fontSize="16px"
                        fontweight={600}
                        textColor="#2A4241"
                      />
                    </Box>
                    <Grid
                      container
                      direction={'row'}
                      columnSpacing={'40px'}
                      className="mt-md mb-lg"
                    >
                      <Grid item xs={9} lg={9}>
                        <CommentTextbox
                          Value={values.comment}
                          placeholder="Comments"
                          name="comment"
                          maxLength={3000}
                          rows={4}
                          handlechange={(e) => {
                            setFieldValue('comment', e);
                          }}
                          placeholderBackgroundColor="var(--thom-mono-gray3-bg)"
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  {/* OLD Data */}
                </Box>
              );
            }}
          </Formik>
          <ModalPopup
            description="formUnsavedChangesMessage"
            open={openModal}
            onCancel={() => {
              setOpenModal(false);
            }}
            onOk={() => {
              formikRef.current?.resetForm();
              setIntakeFamilyHistoryInfo({
                ...intakeFamilyHistoryInfo,
                eics: {
                  ...intakeFamilyHistoryInfo.eics,
                  parent: intakeFamilyHistoryInfo.eics.parent,
                },
              });
              setOpenModal(false);
            }}
            labelId1="Clientpage.Nobtn"
            negativeActionLabel="No"
            labelId2="Clientpage.Yesbtn"
            positiveActionLabel="Yes"
          />
        </Card>
        <Box
          className="mt-md mb-xlg"
          display={'flex'}
          justifyContent={'flex-end'}
        >
          <ButtonComponent
            className="btn-primary btn-cancel alrt_Width_btn mr-md"
            variantType="contained"
            labelId={'cancelText'}
            defaultLabelId={'Cancel'}
            sxProps={{
              display: hasEditPermission ? 'auto' : 'none',
            }}
            onClick={() =>
              handleCancellationFlow()
                ? setOpenModal(true)
                : setOpenModal(false)
            }
          />

          <ButtonComponent
            variantType="contained"
            type="submit"
            className="btn-primary btn-submit"
            labelId={'save'}
            defaultLabelId={'Save'}
            sxProps={{
              display: hasEditPermission ? 'auto' : 'none',
            }}
            onClick={async () => {
              await formikRef.current?.setFieldValue('formHandleFlag', true);
              if (!formikRef.current?.isSubmitting) {
                handleFormSubmit();
              }
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export default IntakeFamilyHistoryInfo;
